import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from 'barte-design-system';
import { AccessCodeGate } from './components/AccessCodeGate/AccessCodeGate';
import { CommentsRoot } from './comments/CommentsLayer';
import { ErrorBoundary } from './comments/ErrorBoundary';
import { Catalogo } from './pages/Catalogo/Catalogo';
import { POS } from './pages/backoffice/POS/POS';
import { Bolsao } from './pages/backoffice/Bolsao/Bolsao';
import { CadastroPlanoTaxas } from './pages/backoffice/CadastroPlanoTaxas/CadastroPlanoTaxas';
import { TaxasCompanyCopiaCola } from './pages/backoffice/TaxasCompanyCopiaCola/TaxasCompanyCopiaCola';
import { DetalhePlanoTaxas } from './pages/backoffice/DetalhePlanoTaxas/DetalhePlanoTaxas';
import { SheetsPreview } from './pages/backoffice/SheetsPreview/SheetsPreview';
import { EdicaoMassaPlano } from './pages/backoffice/EdicaoMassaPlano/EdicaoMassaPlano';
import { DetalhePlanoSheetsPreview } from './pages/backoffice/DetalhePlanoSheetsPreview/DetalhePlanoSheetsPreview';
import { Terminals } from './pages/portal-payfacs/Terminals/Terminals';
import { Pendencias } from './pages/portal-payfacs/Pendencias/Pendencias';
import { PlanoTaxas } from './pages/portal-payfacs/PlanoTaxas/PlanoTaxas';
import { SolicitarMaquininhas } from './pages/portal-payfacs/SolicitarMaquininhas/SolicitarMaquininhas';
import { Transacoes } from './pages/portal-payfacs/Transacoes/Transacoes';
import { BuscaChat } from './pages/portal-payfacs/BuscaChat/BuscaChat';
import { CadastroNovoSeller } from './pages/portal-payfacs/CadastroNovoSeller/CadastroNovoSeller';
import { UsuariosPermissoes } from './pages/portal-payfacs/UsuariosPermissoes/UsuariosPermissoes';
import { DetalheLojista } from './pages/portal-payfacs/DetalheLojista/DetalheLojista';
import { DetalheLojistaSoBolsao } from './pages/portal-payfacs/DetalheLojistaSoBolsao/DetalheLojistaSoBolsao';
import { PrimeiraEntrega } from './pages/portal-sellers/PrimeiraEntrega/PrimeiraEntrega';
import { DashboardSaldos } from './pages/portal-sellers/DashboardSaldos/DashboardSaldos';
import { DashboardSaldosV2 } from './pages/portal-sellers/DashboardSaldosV2/DashboardSaldosV2';
import { DashboardSaldosV3 } from './pages/portal-sellers/DashboardSaldosV3/DashboardSaldosV3';
import { DashboardSaldosV31 } from './pages/portal-sellers/DashboardSaldosV31/DashboardSaldosV31';
import { DashboardSaldosV4 } from './pages/portal-sellers/DashboardSaldosV4/DashboardSaldosV4';
import { DashboardSaldosSemBanking } from './pages/portal-sellers/DashboardSaldosSemBanking/DashboardSaldosSemBanking';
import { DashboardSaldosSemGravamesBolsao } from './pages/portal-sellers/DashboardSaldosSemGravamesBolsao/DashboardSaldosSemGravamesBolsao';
import { DashboardSaldosDisponivelFuturoZerados } from './pages/portal-sellers/DashboardSaldosDisponivelFuturoZerados/DashboardSaldosDisponivelFuturoZerados';
import { DashboardSaldosSemSaque } from './pages/portal-sellers/DashboardSaldosSemSaque/DashboardSaldosSemSaque';
import { DashboardSaldosSellersTimeline } from './pages/portal-sellers/DashboardSaldosSellersTimeline/DashboardSaldosSellersTimeline';

function App() {
  return (
    <ToastProvider position="top-right">
    <BrowserRouter>
      <AccessCodeGate>
      <Routes>
        <Route path="/" element={<Catalogo />} />
        <Route path="/pos" element={<POS />} />
        <Route path="/terminals" element={<Terminals />} />
        <Route path="/pendencias" element={<Pendencias />} />
        <Route path="/plano-taxas" element={<PlanoTaxas />} />
        <Route path="/solicitar-maquininhas" element={<SolicitarMaquininhas />} />
        <Route path="/transacoes" element={<Transacoes />} />
        <Route path="/busca-chat" element={<BuscaChat />} />
        <Route path="/dashboard-saldos" element={<DashboardSaldos />} />
        <Route path="/dashboard-saldos-v2" element={<DashboardSaldosV2 />} />
        <Route path="/backoffice/pos" element={<POS />} />
        <Route path="/backoffice/bolsao" element={<Bolsao />} />
        <Route path="/backoffice/cadastro-plano-taxas" element={<CadastroPlanoTaxas />} />
        <Route path="/backoffice/taxas-company/upload-csv" element={<CadastroPlanoTaxas />} />
        <Route path="/backoffice/taxas-company/copia-cola" element={<TaxasCompanyCopiaCola />} />
        <Route path="/backoffice/taxas-company/plano/:planoId" element={<DetalhePlanoTaxas />} />
        <Route path="/backoffice/sheets/preview" element={<SheetsPreview />} />
        <Route path="/backoffice/taxas-company/plano/:planoId/edicao-massa" element={<EdicaoMassaPlano />} />
        <Route path="/backoffice/sheets/preview/plano/:planoId" element={<DetalhePlanoSheetsPreview />} />
        <Route path="/portal-payfacs/terminals" element={<Terminals />} />
        <Route path="/portal-payfacs/pendencias" element={<Pendencias />} />
        <Route path="/portal-payfacs/plano-taxas" element={<PlanoTaxas />} />
        <Route path="/portal-payfacs/solicitar-maquininhas" element={<SolicitarMaquininhas />} />
        <Route path="/portal-payfacs/transacoes" element={<Transacoes />} />
        <Route path="/portal-payfacs/busca-chat" element={<BuscaChat />} />
        <Route path="/portal-payfacs/cadastro-novo-seller" element={<CadastroNovoSeller />} />
        <Route path="/portal-payfacs/usuarios-permissoes" element={<UsuariosPermissoes />} />
        <Route path="/portal-payfacs/detalhe-lojista" element={<DetalheLojista />} />
        <Route path="/portal-payfacs/detalhe-lojista-so-bolsao" element={<DetalheLojistaSoBolsao />} />
        <Route path="/portal-sellers/primeira-entrega" element={<PrimeiraEntrega />} />
        <Route path="/portal-sellers/dashboard-saldos" element={<DashboardSaldos />} />
        <Route path="/portal-sellers/dashboard-saldos-v2" element={<DashboardSaldosV2 />} />
        <Route path="/portal-sellers/dashboard-saldos-v3" element={<DashboardSaldosV3 />} />
        <Route path="/dashboard-saldos-v3-1" element={<DashboardSaldosV31 />} />
        <Route path="/portal-sellers/dashboard-saldos-v3-1" element={<DashboardSaldosV31 />} />
        <Route path="/dashboard-saldos-v4" element={<DashboardSaldosV4 />} />
        <Route path="/portal-sellers/dashboard-saldos-v4" element={<DashboardSaldosV4 />} />
        <Route path="/portal-sellers/dashboard-saldos-sem-banking" element={<DashboardSaldosSemBanking />} />
        <Route path="/portal-sellers/dashboard-saldos-sem-gravames-bolsao" element={<DashboardSaldosSemGravamesBolsao />} />
        <Route path="/portal-sellers/dashboard-saldos-disponivel-futuro-zerados" element={<DashboardSaldosDisponivelFuturoZerados />} />
        <Route path="/portal-sellers/dashboard-saldos-sem-saque" element={<DashboardSaldosSemSaque />} />
        <Route path="/portal-sellers/dashboard-saldos-sellers-timeline" element={<DashboardSaldosSellersTimeline />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ErrorBoundary>
        <CommentsRoot />
      </ErrorBoundary>
      </AccessCodeGate>
    </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
